import './instrument'

import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import { loadTaxRegions } from './taxData'
import './styles.css'
import './design-system.css'
import './responsive.css'

const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<main><h1>Something went wrong</h1><p>Please refresh the page and try again.</p></main>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)

// The bundled reference directory keeps the public site fully functional without
// third-party auth. Remote sync is opt-in until Firebase Auth and App Check are
// configured to accept the production domain without 401/403 responses.
if (import.meta.env.VITE_ENABLE_FIREBASE_TAX_SYNC === 'true') {
  let taxRegionSyncStarted = false
  const startTaxRegionSync = () => {
    if (taxRegionSyncStarted) return
    taxRegionSyncStarted = true
    window.removeEventListener('pointerdown', startTaxRegionSync)
    window.removeEventListener('keydown', startTaxRegionSync)
    void loadTaxRegions().finally(() => window.dispatchEvent(new Event('tax-regions-loaded')))
  }

  window.addEventListener('pointerdown', startTaxRegionSync, { passive: true, once: true })
  window.addEventListener('keydown', startTaxRegionSync, { once: true })
}
